import { initCommerceApiWithGlobals } from 'common-api';
import { logger } from 'common-ui';
import { useCartStore } from '../../stores/cartStore';

export async function fetchCartWithAtgLegacyApi(): Promise<void> {
  try {
    const commerceApi = initCommerceApiWithGlobals();
    const newCartData = await commerceApi.Cart.get();
    useCartStore.getState().updateCart(prevState => ({
      ...prevState,
      cartIsLoaded: true,
      cartItems: {
        ...prevState.cartItems,
        ...newCartData,
      },
    }));
  } catch (e) {
    logger.error('API ERROR', e);
  }
}
